import script from "./material-request.vue?vue&type=script&lang=js&setup=true"
export * from "./material-request.vue?vue&type=script&lang=js&setup=true"

import "./material-request.vue?vue&type=style&index=0&id=c6444c98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6444c98"]])

export default __exports__